module.exports = __webpack_public_path__ + "img/horseracing.4c1042c3.webp";